import { render, staticRenderFns } from "./splashScreen.vue?vue&type=template&id=4d0bf557&scoped=true&"
import script from "./splashScreen.vue?vue&type=script&lang=js&"
export * from "./splashScreen.vue?vue&type=script&lang=js&"
import style0 from "./splashScreen.vue?vue&type=style&index=0&id=4d0bf557&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0bf557",
  null
  
)

export default component.exports